import { compareGroupLead, GroupLead } from './group-lead';

export interface AwardGroupForStaff {
  awardGroupId: number;
  title: string;
  groupLeads: GroupLead[];
}

export function compareAwardGroupForStaff(awardGroupForStaffA: AwardGroupForStaff, awardGroupForStaffB: AwardGroupForStaff): boolean {
  if (awardGroupForStaffA.awardGroupId !== awardGroupForStaffB.awardGroupId) return false;
  if (awardGroupForStaffA.title !== awardGroupForStaffB.title) return false;

  if (awardGroupForStaffA.groupLeads.length !== awardGroupForStaffB.groupLeads.length) return false;
  awardGroupForStaffA.groupLeads.forEach(groupLeadA => {
    const groupLeadB = awardGroupForStaffB.groupLeads.find(groupLead => groupLead.emailAddress === groupLeadA.emailAddress);
    if (!groupLeadB) return false;
    if (!compareGroupLead(groupLeadA, groupLeadB)) return false;
  })

  return true;
}
